import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const WhooshCrownIcon = (props: IconProps) => (
  <Icon viewBox="0 0 102 41" title={t`Whoosh Crown`} {...props}>
    <Path
      d="M100.157 15.126C98.182 12.9642 94.7746 12.1671 89.0314 17.6501C81.3738 24.9568 78.0748 27.4084 73.3912 27.493C67.7925 27.5896 62.7476 24.2322 60.472 19.1839C58.9309 15.7661 57.2814 10.9957 56.1135 4.61895C55.7763 2.79531 54.6686 1.14075 52.9469 0.379888C52.3449 0.114192 51.6827 -0.0307347 50.9964 0.00549659C50.3101 -0.0307347 49.6479 0.126269 49.0459 0.379888C47.3241 1.14075 46.2164 2.79531 45.8793 4.61895C44.1575 14.027 41.2679 20.0052 39.2812 23.2418C37.9327 25.4399 35.7294 27.022 33.1769 27.5413C27.7106 28.6524 22.2564 26.5268 12.9613 17.6501C7.21817 12.1671 3.81079 12.9642 1.83619 15.126C-0.367166 17.5414 -0.49961 21.1766 0.969296 24.0751L9.30112 40.5H15.9112H86.0815H92.7037L101.035 24.0751C102.504 21.1646 102.36 17.5414 100.157 15.126Z"
      fill="currentColor"
    />
  </Icon>
);

export default WhooshCrownIcon;
